import { baseURL } from "../utils/constants";
import axiosInstance from "../utils/axiosUtil";

export const userQRLoginExternal = async ({
  encryptedSessionId,
  email,
  password,
}: {
  encryptedSessionId: string;
  email: string;
  password: string;
}) => {
    console.log("Session ID:", encryptedSessionId);
    console.log("Email:", email.trim());
    console.log("Password:", password.trim());
  try {
    const res = await axiosInstance.post(
      `${baseURL}/user/qrlogin/external`,
      {
        encryptedSessionId: String(encryptedSessionId).trim(),
        email: email.trim(),
        password: password.trim(),
      },
    { withCredentials: true }
    );
    console.log("QR Login response: ", res.data.result);
    return res;
  } catch (error: any) {
    console.error(error);
    if (error.response || error.response.status === 403) {
      return error.response;
    }
  }
};

export const encryptSessionId =  async function (sessionId: string) {
  try{
    const response = await axiosInstance.post(`${baseURL}/user/qrlogin/encryptid`, {
      session_id: sessionId,
    },{ withCredentials: true });
    return response
  }catch(error:any){
    console.error("Error encrypting session ID:", error);
    return error.response
  }
}

export const checkSessionExpirationAPI =  async function (encryptedSessionId: string) {
  try{
    const response = await axiosInstance.post(`${baseURL}/user/qrlogin/external/isexpired`, {
      encryptedSessionId: encryptedSessionId,
    },{ withCredentials: true });
    return response
  }catch(error:any){
    console.error("Error encrypting session ID:", error);
    return error.response
  }
}